// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast_toast-message__Fuw32 {
  font-size: 14px;
  font-family: var(--default-font-family);
}`, "",{"version":3,"sources":["webpack://./src/component/common/toast-messages/toast.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,uCAAA;AACJ","sourcesContent":[".toast-message{\n    font-size: 14px;\n    font-family: var(--default-font-family);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast-message": `toast_toast-message__Fuw32`
};
export default ___CSS_LOADER_EXPORT___;
